(function(){
  try{
    var conn=navigator.connection||navigator.webkitConnection||navigator.mozConnection;
    var saveData=!!(conn&&conn.saveData);
    var slowConn=!!(conn&&(saveData||(conn.effectiveType&&conn.effectiveType!=='4g')));
    var lookAhead=slowConn?250:700;
    var preloadAhead=function(){
      if(saveData||!('IntersectionObserver' in window))return;
      var noHover=!!(window.matchMedia&&window.matchMedia('(hover:none)').matches);
      var lazy=[].slice.call(document.querySelectorAll('img[loading="lazy"]')).filter(function(img){return !img.closest('.wl-hero-slide')&&!(noHover&&img.classList.contains('hdt-card-product__media--hover'));});
      if(!lazy.length)return;
      var pio=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting)return;
          var img=e.target;
          img.setAttribute('loading','eager');
          if('fetchPriority' in img)img.fetchPriority='low';
          pio.unobserve(img);
        });
      },{rootMargin:lookAhead+'px 0px '+lookAhead+'px 0px'});
      lazy.forEach(function(img){pio.observe(img);});
    };
    var blurUp=function(){
      if(!slowConn||saveData||!('IntersectionObserver' in window))return;
      var imgs=[].slice.call(document.querySelectorAll('.wl-home img, .wl-hero-slide img, .wl-section img'));
      var apply=function(img){
        if(img.__lqip)return;img.__lqip=1;
        if(img.complete&&img.naturalWidth>0)return;
        if(img.closest('header, footer, nav, [class*="payment"], [class*="logo"]'))return;
        var src=img.getAttribute('src')||'';
        if(src.indexOf('/cdn/shop')<0&&src.indexOf('shop_images')<0)return;
        var tiny=/width=\d+/.test(src)?src.replace(/width=\d+/,'width=28'):src+(src.indexOf('?')>-1?'&':'?')+'width=28';
        img.style.backgroundImage='url("'+tiny+'")';
        img.style.backgroundSize='cover';
        img.style.backgroundPosition='center';
        img.style.backgroundRepeat='no-repeat';
        img.addEventListener('load',function(){img.style.backgroundImage='none';},{once:true});
      };
      var bio=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting)return;apply(e.target);bio.unobserve(e.target);});},{rootMargin:'320px 0px'});
      imgs.forEach(function(img){bio.observe(img);});
    };
    var boot=function(){
      blurUp();
      var hero=document.querySelector('.wl-hero-slide.is-active img');
      if(!hero||hero.complete){preloadAhead();return;}
      var started=false;
      var startAhead=function(){if(started)return;started=true;preloadAhead();};
      hero.addEventListener('load',startAhead,{once:true});
      hero.addEventListener('error',startAhead,{once:true});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
    else boot();
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    document.documentElement.classList.add('wl-motion');
    var run=function(){
      var sel=['.wl-cat-tile','.wl-section:not(.wl-section-hero) .wl-sec-head > *','.wl-section:not(.wl-section-hero) .hdt-card-product','.wl-lookbook figure','.wl-trust-item','.wl-artisan-band-inner > *','.wl-review','.wl-lb-main','.wl-lb-cell','.wl-reveal'].join(',');
      var nodes=[].slice.call(document.querySelectorAll(sel));
      if('IntersectionObserver' in window){
        var reveal=function(el,i){el.style.transitionDelay=(Math.min(i,8)*70)+'ms';el.classList.add('is-inview');};
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(!e.isIntersecting)return;
            var el=e.target;
            if(el.classList.contains('wl-hscroll')||el.classList.contains('wl-marquee')){
              var kids=[].slice.call(el.querySelectorAll(sel));
              kids.forEach(function(k,i){if(!k.classList.contains('is-inview'))reveal(k,i);});
            }else{
              var sibs=el.parentElement?[].slice.call(el.parentElement.children).filter(function(c){return c.classList.contains('wl-obs');}):[el];
              var idx=sibs.indexOf(el);if(idx<0)idx=0;reveal(el,idx);
            }
            io.unobserve(el);
          });
        },{threshold:.1,rootMargin:'0px 0px -6% 0px'});
        nodes.forEach(function(n){n.classList.add('wl-obs');io.observe(n);});
        [].slice.call(document.querySelectorAll('.wl-hscroll, .wl-marquee')).forEach(function(c){io.observe(c);});
      }else nodes.forEach(function(n){n.classList.add('is-inview');});
      [].slice.call(document.querySelectorAll('.wl-marquee')).forEach(function(m){
        var track=m.querySelector('.wl-marquee-track');if(!track)return;
        var dur=parseFloat(m.style.getPropertyValue('--wl-marquee-dur'))||30;
        var paused=false,idle,pos=0,last=0,raf=0,half=0;
        var measure=function(){half=track.scrollWidth/2;};
        if(window.ResizeObserver)new ResizeObserver(measure).observe(track);else window.addEventListener('resize',measure);
        window.addEventListener('load',measure);
        var pause=function(){paused=true;clearTimeout(idle);};
        var resume=function(){clearTimeout(idle);idle=setTimeout(function(){paused=false;},1600);};
        ['pointerdown','touchstart','wheel','mouseenter'].forEach(function(ev){m.addEventListener(ev,pause,{passive:true});});
        ['pointerup','pointercancel','touchend','mouseleave'].forEach(function(ev){m.addEventListener(ev,resume,{passive:true});});
        var tick=function(ts){if(!last)last=ts;var dt=ts-last;last=ts;if(paused){pos=m.scrollLeft;if(half&&pos>=half){pos-=half;m.scrollLeft=pos;}}else if(half){pos+=(half/(dur*1000))*dt;if(pos>=half)pos-=half;m.scrollLeft=pos;}raf=requestAnimationFrame(tick);};
        var start=function(){if(!raf){last=0;raf=requestAnimationFrame(tick);}};
        var stop=function(){if(raf){cancelAnimationFrame(raf);raf=0;}};
        if(window.IntersectionObserver)new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){measure();start();}else stop();});},{rootMargin:'100px'}).observe(m);else{measure();start();}
      });
      var abg=document.querySelector('.wl-artisan-bg');var aband=abg&&abg.closest('.wl-artisan-band');
      if(abg&&aband){var ticking=false,active=false;var upd=function(){var r=aband.getBoundingClientRect();var vh=window.innerHeight||document.documentElement.clientHeight;if(r.bottom>0&&r.top<vh){var prog=(vh-r.top)/(vh+r.height);var shift=(prog-.5)*-48;abg.style.transform='translate3d(0,'+shift.toFixed(1)+'px,0) scale(1.14)';}ticking=false;};var onScroll=function(){if(!active)return;if(!ticking){ticking=true;requestAnimationFrame(upd);}};window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll,{passive:true});if(window.IntersectionObserver)new IntersectionObserver(function(es){es.forEach(function(e){active=e.isIntersecting;if(active)onScroll();});},{rootMargin:'300px 0px'}).observe(aband);else{active=true;onScroll();}}
      if(window.matchMedia&&window.matchMedia('(hover:hover)').matches){var mags=document.querySelectorAll('.wl-btn-primary, .wl-hero-btn');[].forEach.call(mags,function(btn){btn.addEventListener('mousemove',function(e){var r=btn.getBoundingClientRect();var mx=e.clientX-r.left-r.width/2;var my=e.clientY-r.top-r.height/2;btn.style.transform='translate('+(mx*.16).toFixed(1)+'px,'+(my*.30).toFixed(1)+'px)';});btn.addEventListener('mouseleave',function(){btn.style.transform='';});});}
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  }catch(e){}
})();